import patch from './patch';

const closedToast = { on: false, title: '', message: '', style: 'info' };

export const closeToast = () => patch({
  ui: { toast: closedToast },
});

export const toast = (toastData, duration = 8000) => (dispatch, _getState) => {
  dispatch(patch({ ui: { toast: { on: true, ...toastData } } }));
  setTimeout(() => {
    dispatch(patch({ ui: { toast: closedToast } }));
  }, duration);
};
